import config from "../branding/default/js/config";

const initialState = {
  username: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  password: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
    dontmatch: null,
  },
  firstname: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  lastname: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  address: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  postcode: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  city: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  email: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  phonenumber: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  mobilenumber: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  textphonenumber: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  isdnnumber: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  gggnumber: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  faxnumber: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  sipaddress: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  registrationInProgress: false,
  registrationComplete: false,
  registrationError: false,
  registrationErrorText: null,
  recaptchavalid: false,
};

const registrationReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CONFIG_INIT_REGISTRATION":
      state = {
        ...state,
        username: {
          ...state.username,
          visible: contains(action.payload.WEB_REGISTRATION_FIELDS, "username"),
          required: contains(action.payload.WEB_REQUIRED_FIELDS, "username"),
          regex: "^[a-z0-9\\-\\.]{5,100}$",
          regexText: action.payload.config.text("common.username_helptext"),
        },
        password: {
          ...state.password,
          visible: contains(action.payload.WEB_REGISTRATION_FIELDS, "password"),
          required: contains(action.payload.WEB_REQUIRED_FIELDS, "password"),
          regex: config.password.passwordregex,
          regexText: action.payload.config.text("common.password1_helptext"),
          dontmatch: action.payload.config.text("common.password2_helptext"),
        },
        firstname: {
          ...state.firstname,
          visible: contains(
            action.payload.WEB_REGISTRATION_FIELDS,
            "firstname"
          ),
          required: contains(action.payload.WEB_REQUIRED_FIELDS, "firstname"),
        },
        lastname: {
          ...state.lastname,
          visible: contains(action.payload.WEB_REGISTRATION_FIELDS, "lastname"),
          required: contains(action.payload.WEB_REQUIRED_FIELDS, "lastname"),
        },
        address: {
          ...state.address,
          visible: contains(
            action.payload.WEB_REGISTRATION_FIELDS,
            "street address"
          ),
          required: contains(
            action.payload.WEB_REQUIRED_FIELDS,
            "street address"
          ),
        },
        postcode: {
          ...state.postcode,
          visible: contains(
            action.payload.WEB_REGISTRATION_FIELDS,
            "post code"
          ),
          required: contains(action.payload.WEB_REQUIRED_FIELDS, "post code"),
        },
        city: {
          ...state.city,
          visible: contains(action.payload.WEB_REGISTRATION_FIELDS, "city"),
          required: contains(action.payload.WEB_REQUIRED_FIELDS, "city"),
        },
        email: {
          ...state.email,
          visible: contains(
            action.payload.WEB_REGISTRATION_FIELDS,
            "email address"
          ),
          required: contains(
            action.payload.WEB_REQUIRED_FIELDS,
            "email address"
          ),
          // eslint-disable-next-line
          regex: "[A-Za-z0-9._-]+@[A-Za-z0-9._-]+[.]{1}[A-Za-z]{2,4}$",
          regexText: action.payload.config.text("common.email_helptext"),
        },
        phonenumber: {
          ...state.phonenumber,
          visible: contains(
            action.payload.WEB_REGISTRATION_FIELDS,
            "phone number"
          ),
          required: contains(
            action.payload.WEB_REQUIRED_FIELDS,
            "phone number"
          ),
        },
        mobilenumber: {
          ...state.mobilenumber,
          visible: contains(
            action.payload.WEB_REGISTRATION_FIELDS,
            "mobile number"
          ),
          required: contains(
            action.payload.WEB_REQUIRED_FIELDS,
            "mobile number"
          ),
        },
        textphonenumber: {
          ...state.textphonenumber,
          visible: contains(
            action.payload.WEB_REGISTRATION_FIELDS,
            "textphone"
          ),
          required: contains(action.payload.WEB_REQUIRED_FIELDS, "textphone"),
        },
        isdnnumber: {
          ...state.isdnnumber,
          visible: contains(
            action.payload.WEB_REGISTRATION_FIELDS,
            "isdn number"
          ),
          required: contains(action.payload.WEB_REQUIRED_FIELDS, "isdn number"),
        },
        gggnumber: {
          ...state.gggnumber,
          visible: contains(
            action.payload.WEB_REGISTRATION_FIELDS,
            "3g number"
          ),
          required: contains(action.payload.WEB_REQUIRED_FIELDS, "3g number"),
        },
        faxnumber: {
          ...state.faxnumber,
          visible: contains(
            action.payload.WEB_REGISTRATION_FIELDS,
            "fax number"
          ),
          required: contains(action.payload.WEB_REQUIRED_FIELDS, "fax number"),
        },
        sipaddress: {
          ...state.sipaddress,
          visible: contains(
            action.payload.WEB_REGISTRATION_FIELDS,
            "sip address"
          ),
          required: contains(action.payload.WEB_REQUIRED_FIELDS, "sip address"),
        },
      };
      break;
    case "REGISTRATION_INIT":
      state = {
        ...state,
        registrationInProgress: true,
        registrationComplete: false,
        registrationError: false,
      };
      break;
    case "REGISTRATION_SUCCESS":
      state = {
        ...state,
        registrationInProgress: false,
        registrationComplete: true,
        registrationError: false,
      };
      break;
    case "REGISTRATION_ERROR":
      state = {
        ...state,
        registrationInProgress: false,
        registrationComplete: false,
        registrationError: true,
        registrationErrorText: action.payload,
      };
      break;
    case "REGISTRATION_CLEAR":
      state = {
        ...state,
        registrationInProgress: false,
        registrationComplete: false,
        registrationError: false,
        registrationErrorText: null,
        recaptchavalid: false,
      };
      break;
    case "REGISTRATION_RECAPTCHA_VALID":
    case "REGISTRATION_RECAPTCHA_INVALID":
      state = {
        ...state,
        recaptchavalid: action.type === "REGISTRATION_RECAPTCHA_VALID",
      };
      break;
    default:
      break;
  }
  return state;
};

function contains(str, substr) {
  return str.indexOf(substr) !== -1;
}

export default registrationReducer;






// WEBPACK FOOTER //
// ./src/reducers/registrationReducer.js